import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { FinalidadesService } from '../../services/finalidades.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { FinalidadesEditComponent } from '../finalidades-edit/finalidades-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';

@Component({
  selector: 'app-finalidades',
  templateUrl: './finalidades.component.html',
  styleUrls: ['./finalidades.component.scss']
})
export class FinalidadesComponent implements OnInit {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;

  createColumnDef() {
    const columnDefs = [
      { headerName: this.translate.instant('finalidad.ag_codEntidad'), field: 'codFinalidad', cellClass: 'grid-opendialog', width: 100, minWidth: 150 },
      { headerName: this.translate.instant('finalidad.ag_Nombre'), field: 'nombre', cellClass: 'grid-opendialog', width: 260, minWidth: 150 },
      { headerName: this.translate.instant('finalidad.ag_NombrePT'), field: 'nombre_PT', width: 260, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdDate'), field: 'createdDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.createdByName'), field: 'createdByName', minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedDate'), field: 'updatedDate', cellRendererFramework: CellDateFormatterComponent, minWidth: 150 },
      { headerName: this.translate.instant('auditableEntity.updatedByName'), field: 'updatedByName', minWidth: 150 },

    ]

    return columnDefs;
  }

  dialogConfig: MatDialogConfig;
  constructor(private _FinalidadesService: FinalidadesService, private _router: Router, private _route: ActivatedRoute, private _dialog: MatDialog, _translateService: TranslateService) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
  }

  public defaultColDef = {
    // set every column width
    width: 100,
    // make every column editable
    // make every column use 'text' filter by default
    filter: 'agTextColumnFilter'
  };

  public rowData: any;
  searchTerm: FormControl = new FormControl();

  ngOnInit() {

    this._FinalidadesService.getFinalidades().subscribe(data => { this.rowData = data });

  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  private hasSelectedRow(): boolean {
    console.log(this.gridApi.getSelectedNodes().length);
    return (this.gridApi.getSelectedNodes().length == 1);
  }

  public newItem() {

    let ref = this._dialog.open(FinalidadesEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      this._FinalidadesService.getFinalidades().subscribe(data => { this.rowData = data });
    });
  }





  public onCellClickedEvent($event) {

    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf("grid-opendialog") >= 0) {

      let dlgRef = this._dialog.open(FinalidadesEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        this._FinalidadesService.getFinalidades().subscribe(data => { this.rowData = data });
      });
    }
  }

}
